import React from "react";
export default (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 22",
    style: {
      height: "1em",
      width: "0.95455em"
    },
    className: "icon"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("ellipse", {
    cx: "10.5",
    cy: "11",
    fill: "#2BCDC0",
    rx: "10.5",
    ry: "11"
  }), React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    transform: "translate(5 7)"
  }, React.createElement("path", {
    d: "M3.66748148 8L11 0M3.66707407 8L0 4"
  }))));
});